export default {
    title: "Catálogo",
    noAvailableItems: "Não há produtos disponíveis para encomenda."
}